import React from 'react';
import './index.scss';
import TextInput from 'components/atoms/Input/TextInput';
import PcErrorArea from 'components/molecules/PcErrorArea';

const SpInputHourSalary = ({
  // 表示
  hourSalaryMin,
  // input
  value,
  onChange,
  onInput,
  onCompositionEnd,
  maxLength,
  placeholder,
  // エラー
  inValid,
  errMessage,
  apiErrMessage
}) => {
  return (
    <div className="SpInputHourSalary">
      <div className="SpInputHourSalary-wrapper">
        <div className='title-area'>
          <div className='title'>
            請求金額目安（1時間当たり）
          </div>
          <div className='notice'>
            ※交通費は別途ご請求となります
          </div>
        </div>
        <div className='input-hour-salary'>
          <span>{hourSalaryMin}</span>
          <span className='hourSalary-label'>円</span>
          <span className='hourSalary-label'>～</span>
          <TextInput
            val={value}
            onChange={onChange}
            onInput={onInput}
            onCompositionEnd={onCompositionEnd}
            maxLength={maxLength}
            placeholder={placeholder}
            inValid={inValid}
          />
          <span className='hourSalary-label'>円</span>
        </div>
        <PcErrorArea position='' message={errMessage} />
      </div>
      <div className='api-err'>
        <PcErrorArea position='' message={apiErrMessage} />
      </div>
    </div>
  );
};

export default SpInputHourSalary;